fragment CraftAssetFragment on assets_Asset {
  kind
  url
  width
  height
  title
}
